import React, { Component } from 'react';
import { Layout, Row, Col } from 'antd';

import Form from '../components/layout/loginForm';

class Login extends Component {
    render() {
        return (
            <Layout className="mh-100-vh">
                <Row type="flex" justify="space-around" align="middle" className="mh-100-vh">
                    <Col xs={{ span: 18 }} sm={{ span: 12 }} md={{ span: 6 }} >
                        <Form />
                    </Col>
                </Row>
            </Layout>
        );
    }
}

export default Login;
